import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Students
const StudentListPage = lazy(
  () => import("@/features/admin-view/students/pages/student-list")
);
const CreateStudentPage = lazy(
  () => import("@/features/admin-view/students/pages/create-student")
);
const UpdateStudentPage = lazy(
  () => import("@/features/admin-view/students/pages/create-student")
);
const StudentDetailsPage = lazy(
  () => import("@/features/admin-view/students/pages/student-details")
);
const ImportStudentPage = lazy(
  () => import("@/features/admin-view/students/pages/import-student")
);
const ImportFilesListPage = lazy(
  () => import("@/features/admin-view/students/pages/student-import-files-list")
);
const ErrorListPage = lazy(
  () =>
    import("@/features/admin-view/students/pages/student-import-errors-list")
);
const ErrorDetailsPage = lazy(
  () => import("@/features/admin-view/students/pages/errors-details")
);
const EnrollStudentPage = lazy(
  () => import("@/features/admin-view/students/pages/enroll-student")
);
const StartNewSchoolYearPage = lazy(
  () => import("@/features/admin-view/students/pages/start-new-school-year")
);
const BulkReassignClassPage = lazy(
  () => import("@/features/admin-view/students/pages/bulk-reassign-class")
);

export const studentsRoutes: RouteObject[] = [
  {
    path: "/admin/students",
    element: (
      <RequirePermission resource="students">
        <StudentListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/create",
    element: (
      <RequirePermission resource="students">
        <CreateStudentPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/:studentId/edit",
    element: (
      <RequirePermission resource="students">
        <UpdateStudentPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/:studentId",
    element: (
      <RequirePermission resource="students">
        <StudentDetailsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/import",
    element: (
      <RequirePermission resource="students">
        <ImportStudentPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/import-files-list",
    element: (
      <RequirePermission resource="students">
        <ImportFilesListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/errors-list/:importId",
    element: (
      <RequirePermission resource="students">
        <ErrorListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/errors-details/:importId/:id",
    element: (
      <RequirePermission resource="students">
        <ErrorDetailsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/enroll",
    element: (
      <RequirePermission resource="students">
        <EnrollStudentPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/start-new-school-year",
    element: (
      <RequirePermission resource="students">
        <StartNewSchoolYearPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/students/bulk-reassign-class",
    element: (
      <RequirePermission resource="students">
        <BulkReassignClassPage />
      </RequirePermission>
    ),
  },
];
